'use strict'
module.exports = {
  env: 'live',
  assets: 'https://assets.yike.fm/',
  subDir: 'source',
  mta: {
      AppId: 500486480,
      HidHome: '5b3ad3ba142bb'
  },
  studentPreUrl: 'https://student.yike.fm',
  teacherPreUrl: 'https://teacher.yike.fm',
  apiPreUrl: 'https://yike.fm'
}



//////////////////
// WEBPACK FOOTER
// ./config/local.js
// module id = mMs5
// module chunks = 45 46 47 48 49 50 51 52 53 54 55